import { Container } from "./styles";
import logo_branca from "../../assets/logo_branca_nina.png";
import { Link, useNavigate } from "react-router-dom";
import {
  SignOut,
  List,
  HouseLine,
  CalendarCheck,
  CalendarBlank,
  Users,
  FileText,
  PawPrint,
  InstagramLogo,
  WhatsappLogo,
} from "@phosphor-icons/react";
import { useContext } from "react";
import { AppConText } from "../../context/ContexProvaider";
import { getUser } from "../../context/token";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  InputGroup,
} from "@chakra-ui/react";

const Menus = () => {
  const { logOut } = useContext(AppConText);
  const { role } = getUser();
  const navigator = useNavigate();

  return (
    <Container>
      <>
        <div className="imag">
          <div>
            <Link to={"/telahome"}><img src={logo_branca} /></Link>      
          </div>

          <>
            {role == "tutor" ? (
              <>
                <div className="menu">
                  <Link className="link" to="/home">
                    Home
                  </Link>
                  <Link className="link" to="/agendamentos">
                    Agendamentos
                  </Link>
                </div>
                <div className="menu-hamburguer">
                  <Menu>
                    <MenuButton
                      as={IconButton}
                      aria-label="Options"
                      icon={<List size={32} color="#ffffff" />}
                      variant="unstyled"
                      border={"1px solid #FFFFFF"}
                      alignItems={"center"}
                      display={"flex"}
                    />
                    <MenuList>
                      <MenuItem
                        fontSize={23}
                        _hover={{ backgroundColor: "#CCCCCC" }}
                        icon={<HouseLine size={30} />}
                        onClick={() => navigator("/home")}
                      >
                        Home
                      </MenuItem>
                      <MenuItem
                        fontSize={23}
                        _hover={{ backgroundColor: "#CCCCCC" }}
                        icon={<CalendarCheck size={30} />}
                        onClick={() => navigator("/agendamentos")}
                      >
                        Agendamentos
                      </MenuItem>
                      <MenuItem
                        fontSize={23}
                        _hover={{ backgroundColor: "#CCCCCC" }}
                        icon={<InstagramLogo size={30} />}
                        as="a"
                        href="https://www.instagram.com/hospitalveterinariounileao/"
                        target="_blank"
                      >
                        Instagram
                      </MenuItem>
                      <MenuItem
                        fontSize={23}
                        _hover={{ backgroundColor: "#CCCCCC" }}
                        icon={<SignOut size={32} color="#f90303" />}
                        onClick={() => logOut()}
                        color={"#f90303"}
                      >
                        Sair
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </div>
              </>
            ) : (
              <>
                <div className="menu">
                  <Link className="link" to="/animais">
                    Home
                  </Link>
                  <Link className="link" to="/eventos">
                    Eventos
                  </Link>
                  <Link className="link" to="/agendamentos">
                    Agendamentos
                  </Link>
                  <Link className="link" to="/tutores">
                    Tutores
                  </Link>
                  <Link className="link" to="/relatorios">
                    Relatórios
                  </Link>
                </div>
                <div className="menu-hamburguer">
                  <Menu>
                    <MenuButton
                      as={IconButton}
                      aria-label="Options"
                      icon={<List size={32} color="#ffffff" />}
                      variant="unstyled"
                      border={"1px solid #FFFFFF"}
                      alignItems={"center"}
                      display={"flex"}
                    />
                    <MenuList>
                      <MenuItem
                        fontSize={23}
                        _hover={{ backgroundColor: "#CCCCCC" }}
                        icon={<HouseLine size={30} />}
                        onClick={() => navigator("/animais")}
                      >
                        Home
                      </MenuItem>
                      <MenuItem
                        fontSize={23}
                        _hover={{ backgroundColor: "#CCCCCC" }}
                        icon={<CalendarBlank size={30} />}
                        onClick={() => navigator("/eventos")}
                      >
                        Eventos
                      </MenuItem>
                      <MenuItem
                        fontSize={23}
                        _hover={{ backgroundColor: "#CCCCCC" }}
                        icon={<CalendarCheck size={30} />}
                        onClick={() => navigator("/agendamentos")}
                      >
                        Agendamentos
                      </MenuItem>
                      <MenuItem
                        fontSize={23}
                        _hover={{ backgroundColor: "#CCCCCC" }}
                        icon={<Users size={30} />}
                        onClick={() => navigator("/tutores")}
                      >
                        Tutores
                      </MenuItem>
                      <MenuItem
                        fontSize={23}
                        _hover={{ backgroundColor: "#CCCCCC" }}
                        icon={<FileText size={32} />}
                        onClick={() => navigator("/relatorios")}
                      >
                        Relatórios
                      </MenuItem>

                      <MenuItem
                        fontSize={23}
                        _hover={{ backgroundColor: "#CCCCCC" }}
                        icon={<SignOut size={32} color="#f90303" />}
                        onClick={() => logOut()}
                        color={"#f90303"}
                      >
                        Sair
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </div>
              </>
            )}
          </>
        </div>

        <div className="sair-instagram">
          
          
          {
            role === "tutor"?
          <InputGroup>      
            <Link to="https://www.instagram.com/hospitalveterinariounileao/" target="_blank"><InstagramLogo size={40} color="#ffffff" /></Link>    
          </InputGroup>
          :
          <></>
          }    

          <button onClick={() => logOut()} className="btn">
            <SignOut size={23} color="#ffffff" />            Sair
          </button>
        </div>
      </>
    </Container>
  );
};

export { Menus };
